/* eslint-disable quotes */
export default Object.freeze({
  TITLE: '상품등록',
  TITLE_SET: '상품등록 | 세트상품',
  UPDATE: '상품수정',
  COPY: '상품복사',
  APPROVE: '승인요청',
  SAVE: '저장',
  CANCEL: '취소',
  CLOSE: '닫기',
  SHORT_SAVE: '임시저장',
  SAVED: '번 상품번호가 등록 되었습니다.',
  UDPATE_SAVED: '저장되었습니다.',
  ERROR: '입력 불가한 항목이 있습니다. 다시확인해주세요.',
  SELECT_MALL_NO_ERROR: '쇼핑몰을 선택해주세요.',
  // BasicInfomation
  NAVERPAY_GUIDE: '네이버페이 취급제한상품 안내',
  ADMIN_INPUT: '담당자 입력',
  PARTNER_INPUT: '파트너사명 입력',
  CATEGORY_CLICK: '카테고리 찾기로 변경',
  CATEGORY_SEARCH: '카테고리 검색으로 변경',
  CATEGORY_INPUT: '카테고리명 입력',
  NO_REGISTER_CATEGORY: '등록된 카테고리가 없습니다.',
  CATEGORY_SELECT_GUIDE: '이전 카테고리를 선택해주세요.',
  CATEGORY_SELECTED: '선택한 카테고리',
  FRONT_DISPLAY: '프론트 미노출',
  FRONT_DISPLAY_GUIDE: '프론트 미노출 설정 안내',
  FRONT_DISPLAY_DSC: "'프론트 미노출'이 선택된 상품은 '전시카테고리' 및 '쇼핑몰 검색영역'에 노출되지 않습니다.",
  PLATFORM_DISPLAY: '플랫폼별 노출 설정',
  SEARCHENGINE_DISPLAY: '검색엔진 미노출',
  ALL_GRADE: '전체 회원등급',
  GRAGE_GUIDE: '회원등급을 ‘설정’ 한 상품은 비회원에게 노출되지 않습니다.',
  ALL_GROUP: '전체 회원그룹',
  GROUP_GUIDE: '회원그룹을 ‘설정’ 한 상품은 비회원에게 노출되지 않습니다.',
  PRODUCT_NAME_INPUT: '상품명 입력',
  PRODUCT_NAME_EN_ADD: '영문상품명 등록',
  PRODUCT_NAME_EN_INPUT: '영문상품명 입력',
  PROMOTION_TEXT_ADD: '홍보문구 등록',
  PROMOTION_TEXT_INPUT: '홍보문구 입력',
  PRODUCT_NAME_DSC:
    '판매 상품과 직접 관련이 없는 다른 상품명, 유명 상품 유사문구, 스팸성 키워드 입력 시 관리자에 의해 판매 금지 될 수 있습니다.',
  BRAND_INPUT: '브랜드명 입력',
  MINOR_PURCHASE_YN: '미성년자구매여부',
  MINOR_PURCHASE_YN_TOOLTIP_MESSAGE: '표준카테고리에서 ‘성인 카테고리‘ 선택 시 미성년자 구매여부는 ‘불가능’처리됩니다.',
  PAYCO_POINT: '페이코 포인트',
  NONMEMBER_PURCHASE_YN: '비회원 구매 불가',
  NAVERPAY_YN: '네이버페이 결제 불가',
  CART_DSC: '불가능 설정 시 장바구니 담기가 제한됩니다.',
  KEYWORD_INPUT: '검색어 입력',
  KEYWORD_DSC: "최대 30개 입력 가능합니다. ','로 구분하여 등록 해 주세요",
  REQUIRE_MALL: '쇼핑몰을 선택해 주세요.',
  SEARCH_NONE: '검색결과가 없습니다.',

  RELATED_PRODUCT_CONFIG: '관련상품 설정',
  SELECT_PRODUCT: '개별상품',
  DISPLAY_ORDER: '진열순서',
  AUTO_DISPLAY: '자동진열',
  MANUAL_DISPLAY: '수동진열',
  SELECT_RELATED_PRODUCT: '관련상품 선택',
  REMOVE_SELECTED: '선택삭제',
  PRODUCT_SEARCH: '상품 조회',
  NOTICE_LIMIT_SIZE_1: '상품은 최대 500개까지 선택할 수 있습니다.',
  NOTICE_LIMIT_SIZE_2: '500개를 초과하여 상품 선택 시 기존 선택된 상품이 자동 삭제됩니다.',

  SELECTED_TARGET_MSG: '선택한 상품을',
  NO_DATA_MSG_FOR_RELATED_PRODUCT: '등록된 관련상품이 없습니다.',
  PLZ_SELECT_PRODUCT_TO_MOVE: '이동할 상품을 선택해주세요.',

  //관련상품
  //그리드
  HEADER_NO: 'No.',
  PRODUCT_NO: '상품번호',
  IMMEDIATE_DISCOUNT_AMOUNT: '즉시할인가',
  AMOUNT: '원',
  SALE_STATUS_TYPE: '판매상태',
  SALE_SETTING_STATUS_TYPE: '판매설정',
  EXPOSE_YN: '노출여부',
  DISPLAY_YN: '전시상태',
  DISPLAY_Y: '전시함',
  DISPLAY_N: '전시 안 함',
  SOLD_OUT: '품절상태',
  REMOVE: '삭제',
  SELECT: '선택',
  CONFIRM_REMOVE_N: '선택한 {value}개의 상품을 삭제하시겠습니까?',
  PLZ_SELECT_PRODUCT_TO_REMOVE: '삭제할 상품을 선택해 주세요.',
  Y_EXPOSE: '노출함',
  N_EXPOSE: '노출 안 함',
  Y_STOCK: '정상',
  N_STOCK: '품절',
  AVAILABLE_FOR_SALE: '판매가능',
  STOP_SELLING: '판매중지',
  PROHIBITION_SALE: '판매금지',
  PRE_APPROVAL_STATUS: '승인완료이전',
  SALE_PERIOD: '기간판매',
  ON_PRE_SALE: '예약판매중',
  WAITING_SALE: '판매대기',
  ON_SALE: '판매중',
  END_SALE: '판매종료',
  REMOVED: '삭제가 완료되었습니다.',

  //관련상품alert
  SUCCESS: '성공 {value}건: 대상상품 추가 완료',
  FAIL_DELETED_PRODUCTS: '실패 {value}건: 삭제상품',
  FAIL_PROHIBITED_PRODUCTS: '실패 {value}건: 판매금지 상품',
  FAIL_SELECTED_PRODUCTS: '실패 {value}건: 이미 선택된 상품',

  // 이미지 정보
  IMAGE: '상품 이미지',
  MAIN: '대표',
  ADVISE: '권장',
  ADDITIONAL: '추가',
  ADDITIONAL_IMAGE: '추가이미지',
  IMAGE_ADD_DESCRIPTION:
    '상품이미지 등록 시 자동으로 리스트, 확대, 고정 이미지에 리사이징되어 전시됩니다. (추가이미지 최대 {count}개 등록가능)',
  IMAGE_ADD: '이미지 직접등록',
  EDITOR_PLACEHODER: '- 판매할 상품과 관련된 공지/추가구성 등의 정보를 등록해주세요.',
  IMAGE_MAX_SIZE: '최대 10MB까지 가능합니다.',
  DELIVERY_COMBINATION_N: '묶음배송 불가능 (상품별 배송비 적용)',
  DELIVERY_INTERNATIONAL_DSC1: '해외배송상품 (해외 -',
  DELIVERY_INTERNATIONAL_DSC2: '대한민국으로 배송되는 상품)',
  NO_DELIVERY_TEMPLATE: '등록된 템플릿이 없습니다. 템플릿을 먼저 등록해주세요.',
  DELIVERY_TEMPLATE_MANAGE: '배송템플릿 관리',
  DELIVERY_TYPE: '배송방법',
  RELEASE_ADDRESS: '출고지 주소',
  RETURN_ADDRESS: '반품/교환지 주소',
  RETURN_AMT: '반품/교환지 배송비',
  RETURN_AMT2: '편도기준',
  DELIVERY_CUSTOMER_INFO: '판매자 특이사항',
  DELIVERY_CUSTOMER_INFO2: '고객안내사항',
  NO: '등록 안함',
  DELIVERY_CUSTOMER_INFO_PLACEHODER: '판매자 특이사항 / 고객안내사항을 입력해주세요.',
  RETURN_AMT_GUIDE: '반품/교환배송비 가이드',
  RETURN_AMT_GUIDE1:
    '반품/교환 배송비를 0원으로 입력하는 경우 무료반품/교환으로 설정되니 금액을 정확히 확인하시기 바랍니다.',
  RETURN_AMT_GUIDE2:
    '구매자가 반품/교환 신청 시 계산되는 반품/교환 택배비는 초도배송비와 반품/교환배송비의 합계 금액입니다.',
  RETURN_AMT_GUIDE3: '초도배송비 2,500원(상품구매시 구매자가 이미 지불) + 반품배송비 3,000원 = 반품택배비 5,500원',
  RETURN_AMT_GUIDE4:
    '초도배송비 무료 + 반품배송비 3,000원 = 반품택배비 6,000원 (초도배송비가 무료 일 경우 반품배송비 * 2)',
  REQUIRE_PARTNER: '파트너사가 선택되어야 합니다',
  REQUIRE_MALL_NO: '쇼핑몰이 선택되어야 합니다',
  DELIVERY_TEMPLATE_POP_TITLE: '배송비조건 템플릿 등록',
  REQUIRE_DELIVERY: '세트상품은 배송 상품으로만 등록할 수 있습니다.',
  // 상품항목추가
  ADDITIONAL_TITLE: '상품항목추가정보',
  ADDITIONAL_FIELD: '항목값',
  //판매정보
  RESERVATION_DELIVERY_STARTYMD: '예약배송시작일',
  RESERVATION_DELIVERY_STOCKCNT: '예약재고수량',
  RESERVATION_DSC: '옵션 설정 시, 옵션 별 예약재고수량이 자동으로 합산됩니다.',
  ONLY_NUMBER_INPUT: '숫자만 입력',
  UNIT_PRICE: '단위별 가격 등록',
  INPUT_ERROR: '입력형식이 잘못되었습니다.',
  INPUT_ERROR2: '입력형식이 잘못되었습니다.',
  UNIT: '당',
  UNIT_DSC: '예시 100g당 100원',
  WEIGHT: '무게 등록',
  ERROR_PRICE_TEN: '가격은 10원 단위로 입력 가능합니다.',
  MAX: '최대',
  DISCOUNT_PRICE: '할인적용가',
  ERROR2: '100이하로 입력해주세요',
  PROMOTION_INFO_DSC: '프로모션 설정 안내',
  PROMOTION_INFO_DSC2: '추가할인/쿠폰 모두 선택할 경우: 모든 프로모션 적용 가능',
  PROMOTION_INFO_DSC3: '추가할인만 선택할 경우: 추가할인만 적용 가능',
  PROMOTION_INFO_DSC4: '쿠폰만 선택할 경우: 상품쿠폰(플러스쿠폰 포함), 장바구니쿠폰, 장바구니 배송비쿠폰만 적용 가능',
  PROMOTION_INFO_DSC5:
    "상품등록 시 '가능'으로 설정하더라도 파트너사 기초정보의 '프로모션동의' 여부가 '동의안함'으로 설정되어있을 경우 프로모션에서 제외됩니다.",
  STOCK_DSC: '옵션 설정 시, 옵션 별 재고수량이 자동으로 합산됩니다.',
  MIN_BUY_DSC1: '개 이상 구매 가능',
  MIN_BUY_DSC2: '2 이상으로 입력해주세요.',
  MIN_BUY_DSC3: '최소 2개부터 등록 가능',
  MAX_BUY_PERSON: '1인 구매시 최대',
  MAX_BUY_SUFFIX: '개까지 구매 가능',
  MAX_BUY_TIME: '1회 구매시 최대',
  MAX_BUY_TIME_DSC: '비회원은 1회 최대구매수량 제한만 가능합니다.',
  MAX_BUY_DAY: '일 동안 최대',
  SETOPTION_RESET: '세트옵션초기화',
  OPTION_RESET: '옵션초기화',
  CHANGE: '변경',
  CERTIFICATION_INFO_BUTTON: '조회/등록',
  PLACE_ORIGIN_YN: '원산지 다른 상품 함께 등록',
  CHECK_REPETITION: '중복체크',
  SUCCESS_PRODUCT_MANAGE_CD: '사용할 수 있는 상품관리코드 입니다.',
  ERROR_PRODUCT_MANAGE_CD: '동일한 상품관리코드를 사용하고 있는 상품이 있습니다.',
  ERROR_NOT_SERVICE: '서비스 제공 예정입니다.',
  MANUFACTURE_YMDT_SELECT: '제조일자 선택',
  EXPIRATION_YMDT_SELECT: '유효일자 선택',
  DUTY_CONTENT_TITLE: '상품정보제공고시',
  ERROR_NEED_CATEGORY: '인증정보 입력을 위해 표준카테고리를 먼저 선택해주세요.',
  INPUT_MANAGE_CD: '상품관리코드를 입력해주세요.',
  ERROR_PRICE: '판매가는 즉시할인금액 이상으로만 입력 가능합니다.',
  ERROR_PRICE_OPTION: '판매가는 즉시할인금액과 마이너스 옵션가를 합한 금액 이상으로 입력 가능합니다.',
  ERROR_DISCOUNT_PRICE: '즉시할인금액은 판매가 이하로만 입력 가능합니다.',
  ERROR_DISCOUNT_PRICE_OPTION: '즉시할인금액은 마이너스 옵션가가 적용된 판매가 이하로만 입력 가능합니다.',
  ERROR_MAX_RANGE: '999,999,999 이하로 입력해주세요.',
  INPUT_MALL: '쇼핑몰을 선택해주세요.',
  INPUT_PARTNER: '파트너사를 선택해주세요.',
  INPUT_DELIVERY_TEMPLATE: '배송 템플릿을 선택해주세요.',
  INPUT_OPTIONS: '옵션 등록전 판매가 항목을 우선 입력해주세요.',
  OPTION_CHANGE: '옵션변경',
  SETOPTION_CHANGE: '세트옵션변경',
  OPTION_ADD: '옵션등록',
  SETOPTION_ADD: '세트옵션등록',
  ERROR_COMISSION: '수수료는 100% 미만으로 입력해주세요.',
  CONFIRM_OPTION_RESET: '옵션을 초기화하시겠습니까?',
  UPDATE_SAVED: '번 상품번호가 저장 되었습니다.',
  ERROR_RANGE: '0 ~ 99 사이로 입력해주세요',
  ERROR_COMMISSION: '최소 0% 부터 최대 99.9% 까지 입력 가능합니다.',
  OPTION_RESET_CONFIRM: '옵션이 초기화됩니다.',
  ADDITIONAL_PRODUCT: '추가상품 등록',
  PRODUCT_MANAGEMENT_CD_PLACEHOLDER: '관리코드 입력',
  WEEK: '요일',
  ORDER_DATE: '주문일 기준',
  FROM: '부터',
  ORDER_DATE_DESC: '배송지정일 기간/일자는 영업일 기준으로 계산하여 설정 됩니다.',
  PLACE_KR: '국산',
  PLACE_IMPORT: '수입산',
  PLACE_IMPORT_COMPANY: '수입사',
  PLACE_EX: '기타',
  PLACE_OC: '원양산',
  PLACE_SELECT: '선택',
  PLACE_INPUT: '직접입력',
  CATEGORY_CHANGE_DESC:
    '표준카테고리 변경 시 등록된 원산지, 인증정보, 카테고리수수료, 미성년자구매여부가 초기화 됩니다.',
  BOOKS_CATEGORY_DESC:
    '도서정가제 할인 제한 규정에 따라 표준카테고리 내 도서 카테고리 선택 시 네이버페이 적립가능 표시 불가 처리됩니다.',
  LIQUOR_DESC:
    '주류의 통신판매에 관한 명령위임 고시 제5조(주류 통신판매자의 준수사항)에 의거하여 표준카테고리 內 주류 항목 선택 시 미성년자구매여부는 ‘불가능’ 처리됩니다.',
  MIN_ADDPRICE_ERROR: '마이너스 옵션가는 즉시할인가 이하로 설정 가능합니다.',
  STOCK_MAX_MSG: '옵션 재고수량의 합은 1억을 넘을 수 없습니다.',
  RESTOCK_DESC1: '해당 상품의 재입고 알림 신청 가능여부를 제어할 수 있습니다.',
  RESTOCK_DESC2_1: '입고 시 자동발송 처리되지는 않으며, ',
  RESTOCK_DESC2_2: '[상품관리 > 상품 재입고 알림 신청 관리]',
  RESTOCK_DESC2_3: '에서 신청된 내역 확인 후 별도로 알림을 발송하셔야 합니다.',

  LIQUOR_DESCRIPTION_1:
    '주류의 통신판매에 관한 명령위임 고시 제5조(주류 통신판매자의 준수사항) 중 “제3조제1항 및 제2항의 사업자가 통신판매하는 주류의 상표에는 「미성년자에게 판매할 수 없음」을 표기하여야 한다.”에 의거하여 상품 상세 내용에 주류 통신판매 명령 위임고시 내용을 반드시 기재하여야 합니다.',
  LIQUOR_DESCRIPTION_2: '기본 템플릿 사용 시 주류 통신판매 명령 위임고시 내용이 기본 내용으로 쇼핑몰에 적용됩니다.',
  DIRECT_INPUT: '직접 입력',
  DEFAULT_TEMPLATE: '기본 템플릿 사용',
  ADULT: '(성인)',
  LIMIT_BUY_COUNT_RENTAL: '렌탈PG 정책에 따라 렌탈상품은 1회 구매 시 1개만 구매 가능합니다.',
  RENTAL_DELIVERY_FEE: '렌탈PG 정책에 따라 배송비는 무료입니다.',
  TOOLTIP_DELIVERY_RENTAL_1: '상품유형을 렌탈상품으로 선택한 경우 PG사의 배송비 조건을 확인하시어 선택하시기 바랍니다.',
  TOOLTIP_DELIVERY_RENTAL_2:
    '이니렌탈 : 배송비를 상품가격에 포함해야 함으로 무료배송비 템플릿으로 등록하시기 바랍니다.',
  REFUND_INFO_1: '쇼핑몰 고객이 해당 상품을 주문할 때의 설정값을 따릅니다.',
  REFUND_INFO_2:
    '주문 시 ‘환불가능’ 이었다면, 현재 ‘환불불가’ 더라도 환불신청이 가능하며, 그 반대의 경우도 동일합니다.',
  REFUND_ERROR: '[주문환불] 환불불가 설정 시 최소 하나 이상 선택해야 합니다.',
  INVALID_UPLOAD_ADDABLE_IMAGE_COUNT: '추가이미지는 최대 {count}개까지 등록 가능합니다',
  ALL_EXPOSURE_ICON: '상시노출 아이콘',
  DATE_EXPOSURE_ICON: '기간노출 아이콘',
  TOOLTIP_ICON01: '아이콘 순서는 ‘상품 > 상품 운영 관리 > 아이콘 관리’ 메뉴에서 설정한 순서에 따라 상품 등록/수정 페이지 및 쇼핑몰에 노출됩니다.',
  TOOLTIP_ICON02: '상시노출 아이콘과 기간노출 아이콘을 모두 사용하시는 경우, 상시노출 아이콘 > 기간노출 아이콘 순서로 노출됩니다.',
  NO_ICONS: '등록된 아이콘이 없습니다.',
  CANT_CHANGE_ICONS: '선택한 아이콘 중 선택 불가한 아이콘이 포함되어 있습니다.',
  EXTRA_MANAGEMENT_CODE: '추가관리코드',
  ADDITIONAL_INPUT_ITEM: '추가입력항목',
});
